// Marketing homepage component
// Requirements: 3.1, 3.2, 3.5, 4.1, 4.2, 4.3, 4.4, 4.5

import React from 'react';
import MarketingHeader from './MarketingHeader';
import HeroSection from './HeroSection';
import FeatureShowcase from './FeatureShowcase';
import TestimonialsSection from './TestimonialsSection';
import PricingSection from './PricingSection';
import ContactForm from './ContactForm';
import Footer from '../common/Footer';
import './MarketingHomepage.css';

interface MarketingHomepageProps {
  onLogin: () => void;
  onGetStarted: () => void;
  onNavigateHome?: () => void;
}

export const MarketingHomepage: React.FC<MarketingHomepageProps> = ({
  onLogin,
  onGetStarted,
  onNavigateHome
}) => {
  const handleLearnMore = () => {
    // Scroll to feature showcase section
    const featuresSection = document.getElementById('features-section');
    if (featuresSection) {
      featuresSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleContactSales = () => {
    // Scroll to contact form
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="marketing-homepage">
      {/* Header with Navigation - No AI Assistant on marketing page */}
      <MarketingHeader
        onLogin={onLogin}
        onGetStarted={onGetStarted}
        onNavigateHome={onNavigateHome}
      />

      {/* Main Content */}
      <main className="marketing-main" role="main">
        {/* Hero Section */}
        <HeroSection
          onGetStarted={onGetStarted}
          onLearnMore={handleLearnMore}
        />

        {/* Feature Showcase */}
        <section id="features-section">
          <FeatureShowcase />
        </section>

        {/* Testimonials */}
        <TestimonialsSection />

        {/* Pricing */}
        <PricingSection
          onSelectPlan={(planId, billing) => onGetStarted()}
          onContactSales={handleContactSales}
        />

        {/* Contact Form */}
        <ContactForm />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default MarketingHomepage;